import { createFileRoute, Navigate, Outlet, useNavigate } from "@tanstack/react-router"
import { Section } from "design-system/molecules/Section"
import { useAuthEmployeeQuery } from "modules/auth/hooks/useAuthEmployeeQuery"
import { KnowledgeSuggestions } from "modules/knowledge/components/KnowledgeSuggestions"
import {
  KNOWLEDGE_SUGGESTION_TABS,
  KnowledgeSuggestionTab,
} from "modules/knowledge/lib/knowledgeSuggestionTabs"
import { useDeveloperMode } from "modules/shared/hooks/useDeveloperMode"
import { useTranslation } from "react-i18next"
import { BackofficeType } from "schema"
import { z } from "zod"

const SearchSchema = z.object({
  tab: z.enum(KNOWLEDGE_SUGGESTION_TABS).optional(),
})

export const Route = createFileRoute("/_base/_auth/knowledge/suggestions")({
  validateSearch: SearchSchema,
  component: Component,
})

function Component() {
  const { t } = useTranslation()
  const search = Route.useSearch()
  const navigate = useNavigate()
  const { developerMode } = useDeveloperMode()
  const { data: employee, isPending } = useAuthEmployeeQuery()
  if (isPending) return null
  if (!developerMode || employee?.backofficeType !== BackofficeType.Superadmin) {
    return <Navigate to="/knowledge/knowledge-base" replace />
  }

  function onChangeTab(tab: KnowledgeSuggestionTab) {
    navigate({ to: "/knowledge/suggestions", search: { ...search, tab } })
  }

  return (
    <>
      <Section
        title={t("knowledge.suggestions.title")}
        description={t("knowledge.suggestions.description")}
      >
        <KnowledgeSuggestions tab={search.tab ?? "ready"} onChangeTab={onChangeTab} />
      </Section>
      <Outlet />
    </>
  )
}
